import { PRAZO_DEFAULTS } from './constants';

interface Financeira {
    id: string | number;
    prazo_min?: number | null;
    prazo_max?: number | null;
    parcela_min?: number | null;
    parcela_max?: number | null;
}

interface PrazoRange {
    prazoMin: number;
    prazoMax: number;
    parcelaMin: number | null;
    parcelaMax: number | null;
    parcelasOptions: Array<{ value: number; label: string }>;
}

export const calculatePrazoRange = (selecionadas: Financeira[]): PrazoRange => {
    const financeirasWithRange = selecionadas.filter(
        (f) => f.prazo_min != null || f.prazo_max != null
    );

    const prazoMinValues = financeirasWithRange
        .map((f) => f.prazo_min)
        .filter((v): v is number => v != null);
    // Se nenhuma financeira selecionada informou prazo_min (só prazo_max), não há como
    // calcular um mínimo real — usa 1 em vez de deixar o Math.min de lista vazia virar Infinity.
    const prazoMin =
        financeirasWithRange.length === 0
            ? PRAZO_DEFAULTS.min
            : prazoMinValues.length > 0
                ? Math.min(...prazoMinValues)
                : 1;

    const prazoMax =
        financeirasWithRange.length > 0
            ? Math.max(...financeirasWithRange.map((f) => f.prazo_max ?? 0))
            : PRAZO_DEFAULTS.max;

    const parcelaMin = selecionadas.some((f) => f.parcela_min != null)
        ? Math.min(
              ...selecionadas
                  .map((f) => f.parcela_min ?? Infinity)
                  .filter((v) => v !== Infinity)
          )
        : null;

    const parcelaMax = selecionadas.some((f) => f.parcela_max != null)
        ? Math.max(...selecionadas.map((f) => f.parcela_max ?? 0))
        : null;

    const parcelasOptions = generateParcelasOptions(prazoMin, prazoMax);

    return { prazoMin, prazoMax, parcelaMin, parcelaMax, parcelasOptions };
};

const generateParcelasOptions = (
    min: number,
    max: number
): Array<{ value: number; label: string }> => {
    const options: Array<{ value: number; label: string }> = [];
    const step = max - min <= 12 ? 1 : 6;

    for (let n = Math.floor(min); n <= Math.ceil(max); n += step) {
        options.push({ value: n, label: `${n}x` });
    }

    if (options.length === 0) {
        return PRAZO_DEFAULTS.options.map((n) => ({ value: n, label: `${n}x` }));
    }

    return options;
};
